import request from "@/shared/apis";

const BASE = "venues";

// Build "?k=v&k2=v2" only from defined, non-null filters.
function query(params) {
  const pairs = Object.entries(params || {})
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${v}`);
  return pairs.length ? `?${pairs.join("&")}` : "";
}

const venues = {
  create: (dto) => request.post(BASE, dto),
  update: (id, dto) => request.put(`${BASE}/${id}`, dto),
  get: (id) => request.get(`${BASE}/${id}`),
  list: (params) => request.get(`${BASE}${query(params)}`),
  remove: (id) => request.delete(`${BASE}/${id}`),
};

export default venues;
